export default "__VITE_ASSET__BXe5oOCP__"